// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { API, Auth } from 'aws-amplify';
import { sortString } from '../elasticSearch/sortScripts';
import { MIN_FILTER_LENGTH } from '../infrastructure/constants/common';
import { Member } from '../types/Member';

export async function getAllUsersNew(
  order,
  filterData,
  LastEvaluatedKey,
  getAll
) {
  //List with member id for filtering by phone
  const idList: string[] = [];
  if (
    filterData &&
    filterData.phone &&
    filterData.phone.length >= MIN_FILTER_LENGTH
  ) {
    //Looking for members with this phone
    const membersWithPhone: Member[] = await API.post(
      'party',
      '/parties/adminSearch',
      {
        body: {
          index: 'bach-members',
          query: {
            prefix: {
              'memberPhone.keyword': {
                value: filterData.phone,
              },
            },
          },
        },
      }
    );
    if (membersWithPhone) {
      for (const { joinedAs, memberId } of membersWithPhone) {
        if (joinedAs) {
          idList.push(joinedAs);
        } else {
          idList.push(memberId);
        }
      }
    }
  }
  let query = { match_all: {} };
  if (filterData) {
    const terms = [];
    if (filterData.onlyAdmin) {
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      terms.push({ term: { 'role.keyword': 'superAdmin' } });
    }
    if (filterData.onlyVendor) {
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      terms.push({ term: { 'role.keyword': 'vendor' } });
    }
    if (
      filterData &&
      filterData.email &&
      filterData.email.length >= MIN_FILTER_LENGTH
    ) {
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      terms.push({ match_phrase_prefix: { email: filterData.email } });
    }
    if (
      filterData &&
      filterData.name &&
      filterData.name.length >= MIN_FILTER_LENGTH
    ) {
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      terms.push({ match_phrase_prefix: { name: filterData.name } });
    }
    if (idList.length) {
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      terms.push({
        terms: {
          'id.keyword': idList,
        },
      });
    }
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    query = { bool: { must: terms } };
  }
  const property = order.isString ? `${order.name}.keyword` : order.name;
  let srt;
  if (property === 'name.keyword' || property === 'email.keyword') {
    srt = sortString(order, property);
  } else {
    srt = [{ [property]: order.up ? 'asc' : 'desc' }];
  }
  return API.post('party', '/users/adminSearch', {
    body: {
      from: LastEvaluatedKey,
      size: getAll ? 10000 : 25,
      sort: srt,
      query,
    },
  });
}

export function getUsersByRole(role) {
  const query = {
    bool: {
      must: [
        {
          match_phrase_prefix: {
            role,
          },
        },
      ],
    },
  };
  return API.post('party', '/users/adminSearch', {
    body: {
      query,
    },
  });
}

export function getAllUsers(LastEvaluatedKey, onlyAdmin) {
  let body = { onlyAdmin };
  if (LastEvaluatedKey !== null) {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    body = { ...body, LastEvaluatedKey };
  }
  return API.post('party', '/users/getByPage', { body });
}

export function searchByEmail(email) {
  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
  return API.get('party', `/users/search/email/${email}`);
}

export type User = {
  Item: {
    createDate: string;
    email: string;
    id: string;
    name: string;
    phone: string;
    photo: string;
    role: string;
    status: string;
    userHasAccountAccess: boolean;
    vendors: string[];
  };
};

export function getById(id): Promise<User> {
  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
  return API.get('party', `/users/${id}`);
}

export function deleteUser(userId) {
  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
  return API.del('party', `/users/${userId}`);
}

export function updateUser(user) {
  return API.put('party', '/users/updateUser', { body: user });
}

export function getUserParties(userId) {
  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
  return API.get(
    'party',
    `/parties/getByUser/${userId}?includeDeactivated=true`
  );
}

export function resetPassword(email) {
  return Auth.forgotPassword(email);
}

export function getUserStripeCustomers(userId) {
  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
  return API.get('party', `/users/${userId}/stripe-customers`);
}

export function getUserStripeCharges(userId, stripeCustomerId) {
  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
  return API.get(
    'party',
    `/users/${userId}/stripe-customers/${stripeCustomerId}/charges`
  );
}
